export default __webpack_public_path__ + "static/media/logo-with-tagline.296cbccc.svg";